import $ from 'jquery'
import jsonp from './jsonp.js'
export function getApplyData (country) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `http://qiantu.xdf.cn/wcm/WCMV6/xdf/interface/productGroup_lxsq.jsp?line=${country}`,
      type: 'GET',
      dataType: 'jsonp',
      // crossDomain: true,
      // jsonCallBack: 'jsonpCallback',
      jsonp: 'jsonCallBack',
      // callback: 'jsonCallBack'
    }).then(res => {
      resolve(res.json)
    }).catch(err => {
      reject(err)
    })
  })
}

export function getOverseasData (cityId, code) {
  return new Promise((resolve, reject) => {
    jsonp('http://cmsdt.xdf.cn/xdf_app/index.php', {
      method: 'Course.GetCourseByCategory',
      c: 'soukeapi',
      param: JSON.stringify({'cityId': cityId, 'categoryCode': code, 'pageIndex': 1, 'pageSize': 5})
    }).then(res => {
      resolve(res.ResponseData)
    }).catch(err => {
      reject(err)
    })
  })
}

export function getQiantuData (country) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url:`http://qiantu.xdf.cn/wcm/WCMV6/xdf/interface/productGroup.jsp?line=${country}`,
      dataType:'jsonp',
      jsonp:"jsonCallBack",
      success:function(res){
        resolve(res.json)
      },
      error:function(err){
        reject(err)
      }
    })
  })
}

export function getYouxueData (code) {
  return new Promise((resolve, reject) => {
    jsonp('http://youxue.xdf.cn/api/getcatlist.php', {
      cat_id: code,
      limit: 5,
      callback: 'callback'
    }).then(res => {
      resolve(res[0].LIST)
    }).catch(err => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/js/youxue.js